import { BundeslandLocationsListComponent } from './BundeslandLocationsListComponent';

export function BundeslandLocationsListComponentC(
  props: React.ComponentProps<typeof BundeslandLocationsListComponent>,
) {
  return <BundeslandLocationsListComponent {...props} />;
}
